import { Dropdown as AntDropdown, DropdownProps } from 'antd';
import { FC, useCallback } from 'react';
import { Menu } from './menu';

export const Dropdown: FC<DropdownProps> = (props) => {
  // TODO: extends this to include item edit and item delete
  const dropdownRender: DropdownProps['dropdownRender'] = useCallback(
    (menus) => <Menu {...menus.props} />,
    [],
  );

  return (
    <AntDropdown
      dropdownRender={props.dropdownRender ?? dropdownRender}
      {...props}
    />
  );
};
